// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumbs_wrapper__3H02A","crumb":"Breadcrumbs_crumb__39oBx"};